import { Box, Grid, Switch, SwitchProps } from '@mui/material';
import React from 'react';
import SparkDropdown from './SparkDropdown';
import StepReferenceTextField from 'components/CreateSpark/StepReferenceTextField';
import type { DropdownOption } from 'types/common/DropdownOption';

type SparkDynamicDropdownInputFieldProps = {
  name: string;
  label: string | null | undefined;
  helpText: string | null | undefined;
  subHeaderText: string | null | undefined;
  placeholder: string | null | undefined;
  options?: DropdownOption[];
  isFieldMapped?: boolean;
  isFieldMappable?: boolean;
  onFieldSwitch?: (mapped: boolean) => void;
};

function SparkDynamicDropdownInputField({
  name,
  helpText = '- -',
  label: headerText = '',
  placeholder: placeholderText = '',
  subHeaderText = '',
  options = [],
  onFieldSwitch,
  isFieldMapped,
  isFieldMappable = false,
}: SparkDynamicDropdownInputFieldProps) {
  const [showReferenceField, setShowReferenceField] = React.useState(false);

  const handleFieldSwitch: SwitchProps['onChange'] = (event, checked) => {
    setShowReferenceField(checked);
    onFieldSwitch && onFieldSwitch(checked);
  };
  React.useEffect(() => {
    if (!isFieldMappable) {
      return;
    }
    setShowReferenceField(!!isFieldMapped);
  }, [isFieldMapped, isFieldMappable]);

  return (
    <Box width='100%' position='relative'>
      {showReferenceField ? (
        <StepReferenceTextField
          label={headerText || '- -'}
          name={name}
          key={name}
          helpText={helpText || ''}
          subHeaderText={subHeaderText || ''}
          placeholder={''}
          isMultiline={false}
        />
      ) : (
        <SparkDropdown
          label={headerText || '- -'}
          name={name}
          key={name}
          placeholder={placeholderText || ''}
          helpText={helpText || ''}
          subHeaderText={subHeaderText || ''}
          size={12}
          children={options || []}
        />
      )}
      {isFieldMappable && (
        <Grid item position='absolute' top='-15px' right='0'>
          <Switch
            checked={showReferenceField}
            onChange={handleFieldSwitch}
            defaultChecked={isFieldMapped}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </Grid>
      )}
    </Box>
  );
}

export default SparkDynamicDropdownInputField;
